import { StyledMoreActions, StyledMoreActionsDropdown } from "../../styles/StyledMoreActions";

import DotsIcon from "../../assets/img/icons/dots.svg";
import PropTypes from "prop-types";

export default function MoreActions({ 
	type, 
	options, 
	isDisabled, 
	isOpen, 
	setIsOpen, 
	direction = "right", 
	moreActionsPosition = "relative" 
}) {
	const closedMoreActions = {};

	for (const [key] in isOpen) {
		closedMoreActions[key] = false;
	}

	return (
		<StyledMoreActions
			onClick={() => {
				setIsOpen({
					...closedMoreActions,
					[type]: !isOpen[type],
				});
			}}
			role={type + "-moreActionsButton"}
			moreActionsPosition={moreActionsPosition}
		>
			<img src={DotsIcon} alt="more actions" />
			<StyledMoreActionsDropdown
				className={[isOpen[type] ? "" : "hidden", isDisabled ? "done" : ""]}
				data-testid={type + "-moreActionsDropdown"}
				direction={direction}
			>
				{options.map((e, i) => {
					if (e.display) {
						return (
							<li key={i} onClick={e.click ? e.click : () => {}} data-testid={type + e.testId}>
								{e.name}
							</li>
						);
					}
				})}
			</StyledMoreActionsDropdown>
		</StyledMoreActions>
	);
}

MoreActions.propTypes = {
	type: PropTypes.string,
	options: PropTypes.array,
	isDisabled: PropTypes.bool,
	isOpen: PropTypes.object,
	setIsOpen: PropTypes.func,
	direction: PropTypes.string,
	moreActionsPosition: PropTypes.string,
};
